import { css, StyleSheet } from 'aphrodite';
import { useAuth } from 'react-oidc-context';
import { Grid, Header as SemanticHeader, Image, Label } from 'semantic-ui-react';

import { PrimaryButton } from '@zooplus/ui-components';

import stylesCommons from '../StylesCommons';

const styles = StyleSheet.create({
    header: {
        backgroundColor: '#FFFFFF',
    },
    zooplusLogo: {
        height: '46px',
    },
});

const Header = () => {
    const auth = useAuth();
    const user = auth!.user;
    return (
        <SemanticHeader as="div" attached="top" className={css(styles.header)} block>
            <Grid columns={2}>
                <Grid.Column textAlign="left" verticalAlign="middle">
                    <Image
                        src="/zooplus_logo.svg"
                        className={css(styles.zooplusLogo)}
                        inline={true}
                    />
                    <Label className={css(stylesCommons.headline)}>User Admin</Label>
                </Grid.Column>
                <Grid.Column textAlign="right" verticalAlign="middle">
                    <Label className={css(stylesCommons.headlineSmall)}>
                        {user ? user.profile.name : ''}
                    </Label>
                    <PrimaryButton
                        disabled={!user}
                        onClick={() =>
                            auth.signoutRedirect({ id_token_hint: auth!.user!.id_token })
                        }>
                        {'Logout'}
                    </PrimaryButton>
                </Grid.Column>
            </Grid>
        </SemanticHeader>
    );
};

export default Header;
